module.exports = __webpack_public_path__ + "media/images/relax-8d28b119dbaffb18ea679fadd19ebf0a.jpg";